import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  response: null,
  loading: false,
  error: null,
  callTimes : 0,
  message:'',
  token:null
};

const userData = localStorage.getItem('user') ? localStorage.getItem('user') : null ;
if(userData){
    initialState.response =  JSON.parse(userData);
    initialState.token = userData?.data?.access_token;
}else{
    initialState.response =  null;
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    signup : (state) => {
        state.loading = true;
        state.callTimes++;
    },
    getAdmins : (state) => {
        state.loading = true;
        state.callTimes++;
    },
    signin :(state) =>  {
        state.loading = true;
        state.callTimes++;
    },
    failed: (state, {payload}) => {
        state.error = true;
        state.loading = false;
        state.message = payload?.message || payload?.data?.message || 'Action failed';
    },

    success : (state, {payload})=>{
        if (payload?.data?.access_token) {
            localStorage.setItem('user', JSON.stringify(payload?.data?.name))
            localStorage.setItem('token', payload?.data?.access_token)
            state.token = payload?.data?.access_token;
        }
        state.loading = false;
        state.response = payload;
        state.message = payload?.message || 'Success';
        state.error = null;
    },
    logout : (state)=>{
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      state.response = [];
      state.loading = false;
      state.message = 'Logout Successfully';
  },
    resetState: (state) => {
        state.loading = false;
        state.error = null;
        state.message = '';
    }
  },
})

// Action creators are generated for each case reducer function
export const { signup, getAdmins, signin, success, failed, logout, resetState } = userSlice.actions

export default userSlice.reducer